import React, { Component } from "react";
import {
    Typography,
    Grid,
    List,
    ListItem,
    IconButton,
    withWidth,
    Radio,
    TablePagination,
    Snackbar,
    SnackbarContent,
} from "@material-ui/core";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import DeleteIcon from "@material-ui/icons/Delete";
import LockIcon from "@material-ui/icons/Lock";
import UnlockIcon from "@material-ui/icons/LockOpen";
import ViewedIcon from "@material-ui/icons/Visibility";
import UnviewedIcon from "@material-ui/icons/VisibilityOff";
import { connect } from "react-redux";
import InvoicedIcon from "@material-ui/icons/Payment";
import styled from "styled-components";
import "./submittedReportsStyles.css";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import _ from "lodash";
import { Link } from "react-router-dom";
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
class TableData extends Component {
    constructor(props) {
        super(props);
        this.state = { reportNotPresent: false };
    }
    render() {
        const {
            filterState,
            setFilterState,
            tableData,
            users,
            rowsPerPage,
            page,
            setRowsPerPage,
            setPage,
            reportTitles,
            setStatus,

            setModalInfo,
            width,
            canUpdate,
            canDelete,
        } = this.props;
        return (
            <List style={{ background: "#eee", marginTop: 24 }}>
                <ListItem
                    style={{
                        width: "100%",
                        background: "white",

                        boxShadow:
                            "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                    }}
                >
                    <div style={{ float: "right" }}>
                        <TablePagination
                            colSpan={12}
                            ActionsComponent={TablePaginationHelper}
                            count={tableData === false ? 0 : tableData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onChangePage={(event, page) => setPage(page)}
                            onChangeRowsPerPage={(event) =>
                                setRowsPerPage(event.target.value)
                            }
                            rowsPerPageOptions={[50, 100]}
                        />
                    </div>
                </ListItem>
                <ListItem
                    style={{
                        background: "white",
                        boxShadow:
                            "0 6px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
                    }}
                >
                    <Grid container spacing={4}>
                        {
                            <Grid item sm={12} md={12} lg={2} xl={2}>
                                <Typography
                                    variant="body2"
                                    style={{
                                        marginLeft: 24,
                                        paddingTop: 12,
                                        height: 48,
                                    }}
                                >
                                    <b>Report Details</b>
                                </Typography>
                            </Grid>
                        }
                        {["xl", "lg"].includes(width) && (
                            <Grid item sm={12} md={12} lg={2} xl={2}>
                                <Typography
                                    variant="body2"
                                    style={{
                                        marginLeft: 24,
                                        height: 48,
                                        paddingTop: 12,
                                    }}
                                >
                                    <b>Date Created</b>
                                </Typography>
                            </Grid>
                        )}

                        {["xl", "lg"].includes(width) && (
                            <StatusCell
                                text="Viewed"
                                value="viewed"
                                filterState={filterState}
                                setFilterState={setFilterState}
                            />
                        )}
                        {["xl", "lg"].includes(width) && (
                            <StatusCell
                                text="Unviewed"
                                value="unviewed"
                                filterState={filterState}
                                setFilterState={setFilterState}
                            />
                        )}
                        {["xl", "lg"].includes(width) && (
                            <StatusCell
                                text="Invoiced"
                                value="invoiced"
                                filterState={filterState}
                                setFilterState={setFilterState}
                            />
                        )}

                        {["xl", "lg"].includes(width) && (
                            <Grid item sm={1} md={1} lg={2} xl={2}>
                                <Typography
                                    variant="body2"
                                    style={{
                                        marginLeft: 24,
                                        height: 48,
                                        paddingTop: 12,
                                    }}
                                >
                                    <b>Actions</b>
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </ListItem>
                {tableData &&
                    tableData.map((e, i) => {
                        let linkTo;
                        let user = _.find(users, { uid: e.uid });
                        let reportNotPresent = false;
                        if (
                            e.uid &&
                            e.report_type &&
                            e.subject_child &&
                            e.subject_name
                        ) {
                            linkTo = {
                                pathname: `report-view-standalone/${
                                    e.subject_name
                                }/${e.subject_child}/${e.report_type.replace(
                                    /_/g,
                                    "-"
                                )}/${e.timestamp
                                    .replace(/ /g, "_")
                                    .replace(/:/g, ".")}`,
                            };
                        } else {
                            linkTo = { pathname: "/submitted-reports-v2" };
                            reportNotPresent = true;
                        }
                        return (
                            <StyledListItem
                                borderColor={"#0188cc"}
                                style={{
                                    root: {
                                        borderLeft: "#0188cc",
                                    },
                                }}
                            >
                                <Grid container spacing={4}>
                                    <Grid item sm={12} md={12} lg={2} xl={2}>
                                        <Typography
                                            variant="body2"
                                            style={{ paddingLeft: 24 }}
                                        >
                                            <b>Report: </b>
                                            {reportTitles
                                                ? reportTitles[e.report_type]
                                                : "N/A"}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{ paddingLeft: 24 }}
                                        >
                                            <b>Username: </b>
                                            {user ? user.user_name : "N/A"}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{ paddingLeft: 24 }}
                                        >
                                            <b>Jobpack: </b>{" "}
                                            {e.subject_name === "reports"
                                                ? "N/A"
                                                : e.subject_child}
                                        </Typography>
                                    </Grid>
                                    <Grid item sm={12} md={12} lg={2} xl={2}>
                                        <Typography
                                            variant="body2"
                                            style={{ padding: 24 }}
                                        >
                                            {e.timestamp}
                                        </Typography>
                                    </Grid>
                                    <InfoStatusCell
                                        icon={<ViewedIcon />}
                                        value="viewed"
                                        setStatus={setStatus}
                                        reportValue={e.worksheet_status}
                                        uid={e.uid}
                                        reportType={e.report_type}
                                        timestamp={e.timestamp}
                                        setModalInfo={setModalInfo}
                                        uneditable={e.report_uneditable}
                                        canUpdate={canUpdate}
                                    />
                                    <InfoStatusCell
                                        icon={<UnviewedIcon />}
                                        value="unviewed"
                                        setStatus={setStatus}
                                        reportValue={e.worksheet_status}
                                        uid={e.uid}
                                        reportType={e.report_type}
                                        timestamp={e.timestamp}
                                        setModalInfo={setModalInfo}
                                        uneditable={e.report_uneditable}
                                        canUpdate={canUpdate}
                                    />
                                    <InfoStatusCell
                                        icon={<InvoicedIcon />}
                                        value="invoiced"
                                        setStatus={setStatus}
                                        reportValue={e.worksheet_status}
                                        uid={e.uid}
                                        reportType={e.report_type}
                                        timestamp={e.timestamp}
                                        setModalInfo={setModalInfo}
                                        uneditable={e.report_uneditable}
                                        canUpdate={canUpdate}
                                    />
                                    <Grid item sm={12} md={12} lg={2} xl={2}>
                                        <div
                                            style={{
                                                padding: 12,
                                                minWidth: 100,
                                                display: "flex",
                                                justifyContent: "space-between",
                                            }}
                                        >
                                            <Link to={linkTo}>
                                                <IconButton
                                                    onClick={() => {
                                                        if (reportNotPresent) {
                                                            this.setState({
                                                                reportNotPresent: true,
                                                            });
                                                        }
                                                    }}
                                                    id="viewIcon"
                                                >
                                                    <ViewIcon />
                                                </IconButton>
                                            </Link>

                                            {canDelete && (
                                                <IconButton
                                                    disabled={
                                                        e.report_uneditable
                                                    }
                                                    id="deleteIcon"
                                                    onClick={() => {
                                                        setModalInfo({
                                                            status: "",
                                                            reportType:
                                                                e.report_type,
                                                            timestamp:
                                                                e.timestamp,
                                                            uid: e.uid,
                                                            state: true,
                                                            type: "delete",
                                                            subjectChild:
                                                                e.subject_child,
                                                            subjectName:
                                                                e.subject_name,
                                                        });
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                            )}

                                            <EditableButton
                                                uneditable={e.report_uneditable}
                                                uid={e.uid}
                                                reportType={e.report_type}
                                                timestamp={e.timestamp}
                                                setModalInfo={setModalInfo}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </StyledListItem>
                        );
                    })}

                <Snackbar
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    autoHideDuration={4000}
                    open={this.state.reportNotPresent}
                    onClose={() => {
                        this.setState({ reportNotPresent: false });
                    }}
                >
                    <SnackbarContent
                        style={{
                            backgroundColor: "red",
                            color: "white",
                        }}
                        message="Unable to Find Report, Please Contact System Admin With Report Details"
                    />
                </Snackbar>
            </List>
        );
    }
}

const StatusCell = (props) => {
    return (
        <Grid item sm={1} md={1} lg={2} xl={2}>
            <Typography style={{ paddingLeft: 24 }} variant="body2">
                <b>{props.text}</b>
                <Radio
                    color="primary"
                    checked={props.filterState === props.value}
                    onClick={(event) => {
                        props.filterState === props.value
                            ? props.setFilterState(false)
                            : props.setFilterState(event.target.value);
                    }}
                    value={props.value}
                />
            </Typography>
        </Grid>
    );
};

const InfoStatusCell = (props) => {
    const {
        uid,
        reportType,
        timestamp,
        reportValue,
        value,
        icon,
        setModalInfo,
        uneditable,
        canUpdate,
    } = props;
    return (
        <Grid item sm={12} md={12} lg={2} xl={2}>
            <Typography
                style={{ paddingTop: 12, paddingLeft: 24 }}
                variant="body2"
            >
                {icon}
                <Radio
                    disabled={uneditable || !canUpdate}
                    color="primary"
                    checked={reportValue === value}
                    value={value}
                    onClick={(event) => {
                        if (canUpdate)
                            setModalInfo({
                                status: event.target.value,
                                reportType,
                                timestamp,
                                uid,
                                state: true,
                                type: "info",
                            });
                    }}
                />
            </Typography>
        </Grid>
    );
};

const EditableButton = (props) => {
    const { uneditable, setModalInfo, uid, reportType, timestamp } = props;
    return (
        <IconButton
            onClick={() => {
                setModalInfo({
                    status: !uneditable,
                    uid,
                    reportType,
                    timestamp,
                    type: "edit",
                    state: true,
                });
            }}
            style={{
                border:
                    uneditable === true
                        ? "1px solid orangered"
                        : "1px solid blue",
                color: uneditable === true ? "orangered" : "blue",
                margin: 2,
            }}
        >
            {uneditable && <LockIcon />}
            {!uneditable && <UnlockIcon />}
        </IconButton>
    );
};
export default connect((store) => {
    return {};
}, {})(withWidth()(TableData));
